


































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'

import { timeout, timeoutDefault, groupCollectionByField, maskHour } from '@/utils/common'
import { TipoUsuarioEnum,
  SituacaoEnum,
  EtapaEnum,
  TipoEnvioMensagemEnum,
  CancelarSolicitacaoParam,
  TipoOrigemEnum,
  RequestMessage,
  PendenciaMensagem,
  TipoMensagemEnum,
  TipoDocumentoUpload } from '@/types/_'
// import { EtapaEnum, SituacaoEnum, CancelarSolicitacaoParam, TipoOrigemEnum } from '@/types/_'
import { IPendenciaSolicitacao, PendenciaSolicitacao } from '@/types/implements/PendenciaSolicitacao'
import { Triagem, ITriagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import ModalAdministrativePendency from './modal-administrative-pendency/modal-administrative-pendency.vue'

@Component({
  components: {
    ModalAdministrativePendency,
  },
})
export default class ComponentModalRevisaoCirurgica extends Vue {
  loadClose: boolean = false
  loadConfirmar: boolean = false
  loadCancelamento: boolean = false
  loadingAdministrativePendency: boolean = false

  administrativePendencyModalOpen: boolean = false

  get area() {
    return this.$route.name
  }

  get getAutorizacaoAnexo() {
    if (this.getBackofficeGlobalStore.solicitacao.etapa.key === EtapaEnum.agendamento) {
      return {
        pedidoMedico: true,
        laudo: true,
        cotacaoOpme: true,
        laudoAnestesista: false,
        anexoOperadora: false,
        resumo: true,
      }
    }

    return {
      pedidoMedico: true,
      laudo: true,
      cotacaoOpme: true,
      laudoAnestesista: true,
      anexoOperadora: true,
      resumo: true,
    }
  }

  get getAutorizacao() {
    return this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.Autorizada
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaParcial
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AutorizadaAceitaMedico
      || this.getBackofficeGlobalStore.solicitacao.situacao.key === SituacaoEnum.AguardandoOperadora
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get showModalRevisaoCirurgica() {
    const show = this.getBackofficeGlobalStore.modal.revisaoCirurgica
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalRevisaoCirurgica(val: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'revisaoCirurgica', value: val })
  }

  async confirmarRevisaoCirurgica() {
    this.loadingConfirmar = true
    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingConfirmar = false
      return
    }

    const response = await this.getBackofficeGlobalStore.backofficeAgendamentoRealizaRevisaoCirurgica()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1F615)}`, icon: 'warning', color: '#C62828' })
      this.loadingConfirmar = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: `Revisão cirúrgica confirmado com sucesso! ${String.fromCodePoint(0x1F642)}`, icon: 'done', color: '#2E7D32' })
    await this.closeModal()
    this.loadingConfirmar = false
  }

  async closeModal() {
    this.loadingClose = true
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await timeoutDefault()
    await this.getBackofficeGlobalStore.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeGlobalStore.closeModalRevisaoCirurgica()
    await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    this.getBackofficeGlobalStore.setDisableCancelarSolicitacaoButton(false)
    this.getPendenciaStore.clearPendencia()
    solicitacaoId = ''
    this.loadingClose = false
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'triagem',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  async showModalAdministrativePendency() {
    this.loadingAdministrativePendency = true
    await timeoutDefault()
    this.administrativePendencyModalOpen = true
    this.loadingAdministrativePendency = false
  }

  async closeModalAdministrativePendency() {
    this.loadingAdministrativePendency = true
    await timeoutDefault()
    this.administrativePendencyModalOpen = false
    this.loadingAdministrativePendency = false
  }

  async acceptModalAdministrativePendency(messages: string[]) {
    this.loadingAdministrativePendency = true
    await timeoutDefault()

    this.administrativePendencyModalOpen = false

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.pendenciaSolicitacao.abrirPendenciaAdministrativa(solicitacaoId, { comentarios: messages })

    if (response.success) {
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao abrir a pendência administrativa.', icon: 'warning', color: '#C62828' })
    }

    await timeout(2000)

    this.loadingAdministrativePendency = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_visualizacao')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Hospital
  pendenciaSolicitacao: IPendenciaSolicitacao = new PendenciaSolicitacao()
  triagem: ITriagem = new Triagem()
  mensagem: string = ''
  inputFiles: any[] = []

  loadUpload: boolean = false
  loadPendencia: boolean = false
  loadHistorico: boolean = false
  loadComentarios: boolean = false
  modalPendencia: boolean = false
  modalConfirmarPendencia: boolean = false
  loadConfirmarPendencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadClosePedencia: boolean = false
  loadMensagem: boolean = false

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeAgendamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar a pendência.', icon: 'warning', color: '#C62828' })
    }

    await timeout(2000)
    this.loadingConfirmarPendencia = false
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getDisplayPendencia() {
    return { nomePaciente: this.getBackofficeGlobalStore.solicitacao.paciente.nome,
      nomeMedico: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome }
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get canOpenAdminPendency() {
    if (
      this.getBackofficeGlobalStore.solicitacao
    ) {
      return this.getBackofficeGlobalStore.solicitacao.acoes.abrePendenciaAdministrativa
    }

    return false
  }
}
